import { render, staticRenderFns } from "./ChooseAd.vue?vue&type=template&id=b94ff740"
import script from "./ChooseAd.vue?vue&type=script&lang=js"
export * from "./ChooseAd.vue?vue&type=script&lang=js"
import style0 from "./ChooseAd.vue?vue&type=style&index=0&id=b94ff740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports